/** returns list of accounts
@return { Array }
*/
export const getAccountsList = state => {
    return state.accountsList
}

/** returns accounts types list
@return { Array }
*/
export const getAccountsTypesList = state => {
    return state.accountsTypesList
}
